import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import { categories, movies } from '@/mocks/movies';

const categoryPosterImages: Record<string, string> = {
  'movie-interstellar': 'https://readdy.ai/api/search-image?query=Interstellar%20Chinese%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20warm%20golden%20accents%20professional%20artwork&width=600&height=900&seq=cat-interstellar&orientation=portrait',
  'movie-wandering-earth': 'https://readdy.ai/api/search-image?query=The%20Wandering%20Earth%202%20Chinese%20sci%20fi%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-wandering-earth&orientation=portrait',
  'movie-hi-mom': 'https://readdy.ai/api/search-image?query=Hi%20Mom%20Chinese%20comedy%20drama%20movie%20poster%20design%20warm%20nostalgic%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-hi-mom&orientation=portrait',
  'movie-changjin': 'https://readdy.ai/api/search-image?query=The%20Battle%20at%20Lake%20Changjin%20Chinese%20war%20drama%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-changjin&orientation=portrait',
  'movie-nezha': 'https://readdy.ai/api/search-image?query=Nezha%20Chinese%20animated%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20warm%20golden%20accents%20professional%20artwork&width=600&height=900&seq=cat-nezha&orientation=portrait',
  'movie-fengshen': 'https://readdy.ai/api/search-image?query=Creation%20of%20the%20Gods%20Chinese%20fantasy%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-fengshen&orientation=portrait',
  'movie-lost-her': 'https://readdy.ai/api/search-image?query=Lost%20in%20the%20Stars%20Chinese%20mystery%20thriller%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-lost-her&orientation=portrait',
  'tv-zhenhuan': 'https://readdy.ai/api/search-image?query=Empresses%20in%20the%20Palace%20Chinese%20period%20drama%20poster%20design%20elegant%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-zhenhuan&orientation=portrait',
  'tv-kuangbiao': 'https://readdy.ai/api/search-image?query=The%20Knockout%20Chinese%20crime%20drama%20TV%20series%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-kuangbiao&orientation=portrait',
  'movie-farewell': 'https://readdy.ai/api/search-image?query=Farewell%20My%20Concubine%20Chinese%20classic%20drama%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-farewell&orientation=portrait',
  'movie-fast10': 'https://readdy.ai/api/search-image?query=Fast%20and%20Furious%2010%20action%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-fast10&orientation=portrait',
  'movie-suzume': 'https://readdy.ai/api/search-image?query=Suzume%20Japanese%20animated%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-suzume&orientation=portrait',
  'movie-manjianghong': 'https://readdy.ai/api/search-image?query=Full%20River%20Red%20Chinese%20historical%20comedy%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-manjianghong&orientation=portrait',
  'tv-threebody': 'https://readdy.ai/api/search-image?query=Three%20Body%20Chinese%20sci%20fi%20TV%20series%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-threebody&orientation=portrait',
  'movie-oppenheimer': 'https://readdy.ai/api/search-image?query=Oppenheimer%20historical%20drama%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20warm%20golden%20accents%20professional%20artwork&width=600&height=900&seq=cat-oppenheimer&orientation=portrait',
  'movie-demonslayer': 'https://readdy.ai/api/search-image?query=Demon%20Slayer%20Japanese%20animated%20movie%20poster%20design%20cinematic%20film%20poster%20dark%20background%20professional%20artwork&width=600&height=900&seq=cat-demonslayer&orientation=portrait',
};

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();

  const currentCategory = categories.find((c) => c.slug === slug);

  const filteredMovies = slug === 'hot'
    ? movies
    : movies.filter((m) => m.category === slug);

  const pageTitle = currentCategory ? `${currentCategory.name} - 夜猫电影院` : '分类浏览 - 夜猫电影院';
  const pageDesc = currentCategory
    ? `${currentCategory.description}，夜猫电影院为您精选${currentCategory.name}，高清免费在线观看不卡顿。`
    : '夜猫电影院提供丰富影视分类，动作片、喜剧片、科幻片、恐怖片、电视剧等，高清免费在线观看。';

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.nightowlcinema.com/' },
      { '@type': 'ListItem', position: 2, name: currentCategory ? currentCategory.name : '全部分类', item: `https://www.nightowlcinema.com/category/${slug}` },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <div className="min-h-screen bg-background-950">
        <Navbar />
        <main>
          <section className="pt-24 pb-6 px-4 md:px-6">
            <nav className="flex items-center gap-2 text-sm mb-4" aria-label="Breadcrumb">
              <Link to="/" className="text-foreground-400 hover:text-primary-400 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-foreground-500 text-xs"></i>
              <span className="text-primary-400">{currentCategory ? currentCategory.name : '全部分类'}</span>
            </nav>

            <h1 className="text-2xl md:text-3xl font-bold text-white font-heading">
              {currentCategory ? currentCategory.name : '全部分类'}
            </h1>
            <p className="text-sm text-foreground-400 mt-2">{pageDesc}</p>
          </section>

          <section className="px-4 md:px-6 pb-4">
            <div className="flex items-center gap-2 flex-wrap">
              <Link
                to="/category/hot"
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  slug === 'hot'
                    ? 'bg-primary-500 text-background-950'
                    : 'bg-background-900 text-foreground-300 hover:text-primary-400 border border-background-700/50'
                }`}
              >
                全部推荐
              </Link>
              {categories.filter(c => c.slug !== 'hot').map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                    slug === cat.slug
                      ? 'bg-primary-500 text-background-950'
                      : 'bg-background-900 text-foreground-300 hover:text-primary-400 border border-background-700/50'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </section>

          <section className="px-4 md:px-6 py-6">
            {filteredMovies.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-20">
                <i className="ri-movie-line text-5xl text-foreground-600 mb-4"></i>
                <p className="text-foreground-400 text-lg">暂无该分类的影视内容</p>
                <Link to="/category/hot" className="mt-4 text-primary-400 hover:text-primary-300 transition-colors text-sm">
                  查看热门推荐 →
                </Link>
              </div>
            ) : (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
                {filteredMovies.map((movie) => {
                  const posterSrc = categoryPosterImages[movie.imageSeq] || categoryPosterImages['movie-interstellar'];
                  return (
                    <Link
                      key={movie.id}
                      to={`/article/${movie.id}`}
                      className="group block"
                    >
                      <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3 bg-background-800">
                        <img
                          src={posterSrc}
                          alt={movie.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                          title={`${movie.title} - ${movie.categoryName}在线观看`}
                        />
                        <div className="absolute top-2 right-2 px-2 py-0.5 bg-black/70 rounded text-xs text-primary-400 font-semibold flex items-center gap-1">
                          <i className="ri-star-fill text-[10px]"></i> {movie.rating}
                        </div>
                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                          <span className="text-white text-xs font-medium flex items-center gap-1">
                            <i className="ri-play-circle-fill text-primary-400"></i> 点击观看
                          </span>
                        </div>
                      </div>
                      <h3 className="text-sm font-semibold text-white group-hover:text-primary-400 transition-colors line-clamp-1">
                        {movie.title}
                      </h3>
                      <p className="text-xs text-foreground-400 mt-1">
                        {movie.year} · {movie.categoryName}
                      </p>
                    </Link>
                  );
                })}
              </div>
            )}
          </section>
        </main>
        <Footer />
      </div>
      <script
        dangerouslySetInnerHTML={{
          __html: `
            document.title = "${pageTitle}";
            const metaDesc = document.querySelector('meta[name="description"]');
            if (metaDesc) metaDesc.setAttribute('content', "${pageDesc}");
          `,
        }}
      />
    </>
  );
}